function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n\n    @media (max-width: ", ") {\n      ", "\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from "styled-components";
export var DetailText = styled.span(_templateObject(), props => props.theme.typography.detailText);
export var H1 = styled.h1(_templateObject2(), props => props.theme.typography.h1);
export var H2 = styled.h2(_templateObject3(), props => css(_templateObject4(), props.theme.typography.h2, "".concat(props.theme.breakpoints.MOBILE_2, "px"), props.theme.typography.subHeading));
export var HighlightText = styled.span(_templateObject5(), props => props.theme.typography.highlightText);
export var SmallHeading = styled.span(_templateObject6(), props => props.theme.typography.smallHeading);
export var SmallText = styled.span(_templateObject7(), props => props.theme.typography.smallText);
export var SubHeading = styled.span(_templateObject8(), props => props.theme.typography.subHeading);
export var Text = styled.span(_templateObject9(), props => props.theme.typography.text);